/**
 * Shopify install API — starts the app-install OAuth flow.
 *
 * POST /api/auth/install returns the shop's authorize URL for a
 * TOP-LEVEL redirect (Shopify OAuth refuses iframes/popups for the
 * install grant). The callback lands back on /connectors with either
 * ?shopify=connected or ?shopify_error=<code>.
 */

import { createHeaders } from './apiClient';
import { handleResponse } from './httpResponse';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

export async function startShopifyInstall(shop: string): Promise<string> {
  const response = await fetch(`${API_BASE_URL}/auth/install`, {
    method: 'POST',
    headers: { ...createHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ shop }),
  });

  const data = await handleResponse<{ authorize_url: string }>(
    response,
    `HTTP ${response.status}`
  );
  return data.authorize_url;
}
